import { registerComponent } from "helpers";

registerComponent(
  "truncate-text",
  class TruncateText extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector("[data-truncate-text-content]");

      const observer = new ResizeObserver((entries) => {
        entries.forEach(() => {
          this.setAttribute(
            "truncated",
            content.scrollHeight > content.offsetHeight
          );
        });
      });

      observer.observe(content);
    }
  }
);
